var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "select-wrap" }, [
      _c(
        "div",
        [
          _c("el-date-picker", {
            attrs: {
              clearable: false,
              "unlink-panels": "",
              type: "daterange",
              format: "yyyy-MM-dd",
              "range-separator": "-",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              size: "small"
            },
            on: { change: _vm.onChangeTime },
            model: {
              value: _vm.time,
              callback: function($$v) {
                _vm.time = $$v
              },
              expression: "time"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkbox" },
        [
          _c(
            "el-checkbox-group",
            {
              on: { change: _vm.onChangeCheck },
              model: {
                value: _vm.checkedList,
                callback: function($$v) {
                  _vm.checkedList = $$v
                },
                expression: "checkedList"
              }
            },
            _vm._l(_vm.plainOptions, function(item) {
              return _c(
                "el-checkbox",
                { key: item.value, attrs: { label: item.value } },
                [_vm._v(_vm._s(item.label))]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "select-company" },
        [
          _c(
            "el-select",
            {
              attrs: { size: "small", multiple: "", placeholder: "请选择公司" },
              model: {
                value: _vm.corpId,
                callback: function($$v) {
                  _vm.corpId = $$v
                },
                expression: "corpId"
              }
            },
            _vm._l(_vm.cropOptions, function(item) {
              return _c("el-option", {
                key: item.corpId,
                attrs: { label: item.corpName, value: item.corpId }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.getData }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.exportDetail }
            },
            [_vm._v("导出明细")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "jzbWrap" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              "row-key": function(row) {
                return row.id + "-" + row.orderNumber
              }
            },
            on: { "expand-change": _vm.expandChange }
          },
          [
            _c("el-table-column", {
              attrs: { type: "expand" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: scope.row.loading,
                              expression: "scope.row.loading"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: scope.row.list }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "skuCode", label: "商品编号" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "skuName", label: "商品名称" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "unitName", label: "单位" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "quantity", label: "数量" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "price", label: "价格" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "amount", label: "金额" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "createdOn", label: "交易时间" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.moment(scope.row.createdOn).format("YYYY-MM-DD")
                          ) +
                          "\n        "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "operationType", label: "操作类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("filterOperationType")(
                              scope.row.operationType
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "orderNumber", label: "销售单号" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "amount", label: "交易金额" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n          " + _vm._s(scope.row.amount) + "\n        "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "relativeSubAcctNo", label: "见证宝账号" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "corpName", label: "公司" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [10, 50, 100, 200],
            "page-size": _vm.pagesize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.totalCount
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-771b26b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-771b26b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/TransDetail.vue
// module id = null
// module chunks = 